import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';
import { initializeForm } from '../../../utils/form';
import {
  validateEmail,
  validateNotEmpty,
  validateValueNotTaken,
} from '../../../utils/validators';

$(() => {
  const solicitorFormContainer = $('#solicitor-form-container');
  const solicitorFormCheckbox = $('#checkbox-no-solicitor');
  const primaryPurchaserEmail = $('input#_primary_purchaser_email').val();

  const onSolicitorCheckboxChange = () => {
    solicitorFormContainer.toggleClass('d-none');

    if (solicitorFormCheckbox.prop('checked')) {
      solicitorFormContainer
        .find("input:not([name='submit'])")
        .val('')
        .trigger('change')
        .trigger('clearSelect');
      $("select[name='solicitor-code-phone-number']").prop('selectedIndex', 0);
      solicitorForm.restart();
      solicitorFormCheckbox.val('True');
      $('#auction-registration-next-button').attr('disabled', false);
      EVENT_BUS.dispatch(ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR, {
        error: ADDITIONAL_DETAILS_EVENTS.ERROR.SOLICITOR,
      });
    } else {
      solicitorFormCheckbox.val('False');
      EVENT_BUS.dispatch(ADDITIONAL_DETAILS_EVENTS.ADD_ERROR, {
        error: ADDITIONAL_DETAILS_EVENTS.ERROR.SOLICITOR,
      });
    }
  };

  if (solicitorFormCheckbox.prop('checked')) {
    solicitorFormContainer.toggleClass('d-none');
  }

  const solicitorForm = initializeForm(solicitorFormContainer, {
    preventDefault: true,
    skipInputs: [
      'submit',
      'csrfmiddlewaretoken',
      'button',
      'form_type',
      'country_select_filter',
    ],
    validate: (values) => {
      const errors = {
        ...validateEmail(values, 'solicitor-email'),
        ...validateNotEmpty(values, [
          'solicitor-firm-name',
          'solicitor-last-name',
          'solicitor-first-name',
          'solicitor-city',
          'solicitor-address',
          'solicitor-postal',
          'solicitor-phone',
        ]),
        ...validateValueNotTaken(values, 'solicitor-email', {
          valuesTaken: [primaryPurchaserEmail],
        }),
      };

      let hasErrors = false;
      if (!solicitorFormCheckbox.prop('checked')) {
        hasErrors = !$.isEmptyObject(errors);
      }

      const eventType = hasErrors
        ? ADDITIONAL_DETAILS_EVENTS.ADD_ERROR
        : ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR;

      EVENT_BUS.dispatch(eventType, {
        error: ADDITIONAL_DETAILS_EVENTS.ERROR.SOLICITOR,
      });

      return errors;
    },
  });

  solicitorFormCheckbox.on('change', onSolicitorCheckboxChange);
});
